import baseURLv1 from '@/services/APIConfig.js';
import { mapObjectToQueryParams } from '@/helpers/formatArrayParams';
import { getLocalStorageData, localStorageKeys } from '@/helpers/localStorageHelpers';
import { append, set } from '@/vuex/helpers';

const defaultFilters = {
  notification_types: [],
  flags: [],
  is_seen: 2,
  search: '',
  page: 1,
  page_size: 10,
};

export default {
  namespaced: true,
  state: {
    notifications: [],
    types: [],
    flags: [],
    unseenCount: {
      count: 0,
      count_flagged: 0,
    },
    hasNext: false,
    filters: getLocalStorageData(localStorageKeys.notifications, defaultFilters),
    previous: null,
    next: null,
  },
  mutations: {
    set,
    append,
    update(state, [key, payload]) {
      state[key] = state[key].map((item) => {
        if (item.id === payload.id) {
          item = { ...item, ...payload };
        }

        return item;
      });
    },
    updateFilter(state, { field, payload }) {
      state.filters[field] = payload;
      if (field !== 'page') {
        state.filters.page = 1;
      }
    },
    resetFilters(state, { needToResetIsSeen = false }) {
      if (needToResetIsSeen) {
        state.filters.is_seen = defaultFilters.is_seen;
      }
      state.filters.notification_types = [...defaultFilters.notification_types];
      state.filters.flags = [...defaultFilters.flags];
      state.filters.search = defaultFilters.search;
      state.filters.page = 1;
    },
  },
  actions: {
    async load({ commit, state }, loadAsForeigner = false) {
      const filters = loadAsForeigner ? mapObjectToQueryParams({
        page: state.filters.page,
        page_size: state.filters.page_size,
        is_seen: state.filters.is_seen,
      }) : mapObjectToQueryParams(state.filters);
      const response = await this.$axios.get(`${baseURLv1}/notification/`, {
        params: {
          ...filters,
        },
      });

      const updateListMethod = loadAsForeigner && state.filters.page !== 1 ? 'append' : 'set';

      commit('set', ['hasNext', Boolean(response.data.next)]);
      commit(updateListMethod, ['notifications', response.data.data]);
      commit('set', ['previous', response.data.previous]);
      commit('set', ['next', response.data.next]);
    },

    async loadUnseenCount({ commit }) {
      const response = await this.$axios.$get(`${baseURLv1}/notification/count/`);

      commit('set', ['unseenCount', response]);
    },

    async updateNotification({ commit }, { notificationId, payload }) {
      const response = await this.$axios.$patch(`${baseURLv1}/notification/${notificationId}/`, payload);

      commit('update', ['notifications', response]);
    },

    async loadFlags({ commit }) {
      // TODO: use shared.enums.notification_flags when the names there will not be uppercase
      // const items = await this.$axios.$get(`${baseURLv1}/notification/type/`);
      const items = [
        { id: 10, name: 'Red' },
        { id: 20, name: 'Orange' },
        { id: 30, name: 'Green' },
        { id: 40, name: 'Blue' },
        { id: 50, name: 'Violet' },
      ];
      commit('set', ['flags', items]);
    },
  },
  getters: {
    shouldHidePagination: (state) => state.filters.page === 1 && state.filters.page_size === 10 && !state.hasNext,
    someFilterSelected: (state) => {
      return state.filters.notification_types.length !== defaultFilters.notification_types.length
        || state.filters.flags.length !== defaultFilters.flags.length
        || state.filters.search !== defaultFilters.search;
    },
  },
};
